import { init, track, identify, Identify, setUserId } from '@amplitude/analytics-browser'

export type AppEnvironment = 'production' | 'staging' | 'sandbox' | 'development'

export const initAmplitude = (env: AppEnvironment, apiKey: string) => {
  init(apiKey, {
    defaultTracking: {
      sessions: true,
      pageViews: true
    }
  })

  // Set environment as a user property
  const identifyObj = new Identify()
  identifyObj.set('environment', env)
  identify(identifyObj)
}

export const logEvent = <T extends Record<string, unknown>>(name: string, data?: T) => {
  track(name, data)
}

export const identifyUser = (userId: string) => {
  setUserId(userId)
}
